var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42171 2.27759H2.20482C1.88528 2.27759 1.57883 2.40452 1.35288 2.63047C1.12694 2.85642 1 3.16287 1 3.48241V11.9162C1 12.2357 1.12694 12.5422 1.35288 12.7681C1.57883 12.9941 1.88528 13.121 2.20482 13.121H10.6386C10.9581 13.121 11.2646 12.9941 11.4905 12.7681C11.7165 12.5422 11.8434 12.2357 11.8434 11.9162V7.6993",
    stroke: "#27316F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9406 1.37429C11.1802 1.13464 11.5053 1 11.8442 1C12.1831 1 12.5081 1.13464 12.7478 1.37429C12.9874 1.61395 13.1221 1.93899 13.1221 2.27791C13.1221 2.61683 12.9874 2.94187 12.7478 3.18153L7.02488 8.90444L4.61523 9.50685L5.21765 7.0972L10.9406 1.37429Z",
    stroke: "#27316F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.d750991d0a128316a4d628f95af70bcd.svg";
export { ForwardRef as ReactComponent };